export const email1 = 'service_pw7b4cf';

export const email2 = 'template_nfzcjzj';

export const email3 = 'user_JJjgyIQ76g6ULRwpVGEMS';
